import { useMemo } from "react";
import { PrebookingForm } from "./PrebookingForm";
import { PreCancelQuestion } from "./CancelPrebooking";

export function App() {
    const isCancel = useMemo(() => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.has('cancel')
    }, [])

    if (isCancel) {
        return (<PreCancelQuestion />)
    }

    return (
        <PrebookingForm />
    )
}
